import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import Breadcrumb from "../components/site/Breadcrumb";
import CTABand from "../components/site/CTABand";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    api.faqs().then(setFaqs);
  }, []);

  return (
    <div>
      <section className="bg-[#F8FAF8] border-b border-[#E2E8E4] pt-12 pb-14">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <Breadcrumb items={[{ label: "FAQ" }]} />
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#1D6B2A] mt-6 mb-3">
            Frequently asked questions
          </p>
          <h1 className="font-head text-4xl md:text-6xl font-medium tracking-tighter text-[#0A1C0E]">
            Answers, quickly
          </h1>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-3xl mx-auto px-5 md:px-10">
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-white border border-[#E2E8E4] rounded-2xl px-6 data-[state=open]:shadow-md transition-shadow"
              >
                <AccordionTrigger className="font-head text-lg font-semibold text-[#0A1C0E] hover:no-underline text-left py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#3A4D3E] text-base leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
